import React from 'react';

const FilterButton = ({ 
  onClick, 
  disabled, 
  loading, 
  children = 'Filter',
  ariaLabel = 'Apply filter'
}) => {
  return (
    <button
      className="filter-apply-button"
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel}
    >
      {loading ? 'Filtering...' : children}
    </button>
  );
};

export default FilterButton;